import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';

export const PaymentCancel = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-paper flex items-center justify-center py-16 px-6">
      <div className="max-w-md text-center">
        <XCircle className="w-16 h-16 mx-auto mb-6 text-muted" strokeWidth={1.5} />
        <div className="caps text-muted mb-3">Payment cancelled</div>
        <h1 className="font-serif text-4xl md:text-5xl mb-4" data-testid="payment-cancel-title">
          No problem, <em className="italic">try again</em> anytime.
        </h1>
        <p className="text-muted mb-8">Your payment was cancelled. You can retry whenever you&apos;re ready.</p>
        <button onClick={() => navigate('/list-property')} className="btn-editorial btn-solid">
          Try again →
        </button>
      </div>
    </div>
  );
};
